// Groups thousands with a non-breaking space (PL formatting) so large values
// like step counts render as "20 000". Values below 10 000 stay untouched to
// avoid churn on common reps/weights.
export const formatFitnessNumber = (value: number): string => {
  if (!Number.isFinite(value) || Math.abs(value) < 10_000) {
    return String(value);
  }
  const [integer = "", fraction] = String(value).split(".");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return fraction ? `${grouped}.${fraction}` : grouped;
};
